export default "__VITE_ASSET__BZp$axs7__"